<!-- src/components/UpdatePrompt.vue -->
<template>
  <div v-if="show" class="update-overlay">
    <div class="update-content">
      <p>새로운 버전이 출시되었습니다.</p>
      <button @click="refreshApp">지금 업데이트</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      onConfirm: {
        type: Function,
        required: true,
      },
    },
    methods: {
      refreshApp() {
        this.onConfirm()
      },
    },
  }
</script>

<style scoped>
  .update-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  .update-content {
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  }
  .update-content p {
    font-size: var(--font-size-10);
    margin-bottom: 1rem;
    color: #333;
  }
  .update-content button {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border-radius: 8px;
    cursor: pointer;
  }
</style>
